import { render, staticRenderFns } from "./ValidatedGroup.vue?vue&type=template&id=9dc4152c"
import script from "./validatedGroup.ts?vue&type=script&lang=ts&external"
export * from "./validatedGroup.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports